module.exports = __webpack_public_path__ + "static/media/SDFSA_1-835w.0b4169df.png";